import React from 'react';
import './InfoSection.css';
import { COMMON_DATE } from '../App'
import { format } from 'date-fns'

const InfoSection = ({ info }) => {

  const generated = format(new Date(info?.generated), COMMON_DATE);

  return (
    <div className="info-section">
      <p>Data generacji: {generated}</p>
    </div>
  );
};

export default InfoSection;
